<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="wo"
          :listCatalog="listCatalog"
          :listInvoiceVendor="listInvoiceVendor"
          :listInvoiceCustomer="listInvoiceCustomer"
          :listPaymentVendor="listPaymentVendor"
          :listPaymentCustomer="listPaymentCustomer"
          :listGeneralKasbon="listGeneralKasbon"
          :listDriverKasbon="listDriverKasbon"
          :listInstallerKasbon="listInstallerKasbon"
          :listEmployee="listEmployee"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail :form="wo" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="updateItem">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="editItem">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click.stop="deleteDialog">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="`${wo.id}`"
      title="WO"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
  </form>
</template>

<script>
import Detail from "./DetailWo";
import FormEdit from "./FormWo";
import DialogDelete from "@/components/DialogDelete";
import { mapState } from "vuex";

export default {
  name: "wo-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
  },
  props: {
    id: Number,
  },
  data: () => ({
    edit: true,
    dialog: false,
    wo: {},
  }),
  computed: {
    ...mapState("wo", [
      "listCatalog",
      "listInvoiceVendor",
      "listInvoiceCustomer",
      "listPaymentVendor",
      "listPaymentCustomer",
      "listGeneralKasbon",
      "listDriverKasbon",
      "listInstallerKasbon",
      "listEmployee",
    ]),
  },
  methods: {
    async getWo() {
      await this.$store.dispatch("wo/getById", this.id).then(response => {
        this.wo = response.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    deleteItem(id) {
      this.$store.dispatch("wo/delete", id);
      this.dialog = false;
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.getWo();
      this.edit = true;
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        await this.$store.dispatch("wo/getCatalog"),
        this.getWo(),
        await this.$store.dispatch("wo/getInvoiceVendor"),
        await this.$store.dispatch("wo/getInvoiceCustomer"),
        await this.$store.dispatch("wo/getPaymentVendor"),
        await this.$store.dispatch("wo/getPaymentCustomer"),
        await this.$store.dispatch("wo/getGeneralKasbon"),
        await this.$store.dispatch("wo/getDriverKasbon"),
        await this.$store.dispatch("wo/getInstallerKasbon"),
        await this.$store.dispatch("wo/getEmployee"),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
